import { render, staticRenderFns } from "./VFormItemLogo.vue?vue&type=template&id=5a15d332&"
import script from "./VFormItemLogo.vue?vue&type=script&lang=js&"
export * from "./VFormItemLogo.vue?vue&type=script&lang=js&"
import style0 from "./VFormItemLogo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports